/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LevelOfInvoiceEnumDto {
  ORGANIZATION = 'Organization',
  DEPARTMENT = 'Department',
}
